import { Chip, useTheme } from '@mui/material';

import { ATSConnectHiringRequestCandidateFeedbackTestIds } from 'data-testids/ATS';
import { CandidateFeedbackModalTypes } from '../../../enums';
import { ChipContainer, completedRowSx, draftRowSx, pendingRowSx } from '../../../styles/styles';
import { CompletionChipProps } from '../../../types/feedbackDetailTypes';

export const CompletionChip: React.FC<CompletionChipProps> = ({
  isComplete,
  modalType,
  isPending,
}) => {
  const theme = useTheme();

  const getChipText = () => {
    if (isComplete) return 'Complete';

    switch (modalType) {
      case CandidateFeedbackModalTypes.SCORECARD:
        return 'Draft';
      case CandidateFeedbackModalTypes.REFERENCE:
        if (isPending) {
          return 'Pending';
        }
        return 'Draft';
      default:
        return '';
    }
  };

  return (
    <ChipContainer>
      <Chip
        data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.COMPLETION_CHIP}
        label={getChipText()}
        sx={
          isComplete ? completedRowSx(theme) : isPending ? pendingRowSx(theme) : draftRowSx(theme)
        }
        variant="filled"
      />
    </ChipContainer>
  );
};
